/**
 * FeedbackLogicRuleOperator
 */
export enum FeedbackLogicRuleOperator {
    SELECTED = 'selected',
    NOT_SELECTED = 'not_selected',
    IS_EMPTY = 'is_empty',
    IS_NOT_EMPTY = 'is_not_empty',
    LESS_THAN = 'less_than',
    GREATER_THAN = 'greater_than',
    EQUAL_TO = 'equal_to',
    NOT_EQUAL_TO = 'not_equal_to',
    CONTAINS = 'contains',
    NOT_CONTAINS = 'not_contains'
}
